import { elevatedTags } from '../shared/constants';

export const mapTags = (tags: string[] | null): { label: string; severity: 'warning' | 'neutral' }[] => {
    return (
        (tags || [])
            .map((tag) => ({
                label: tag,
                severity: elevatedTags.includes(tag) ? ('warning' as const) : ('neutral' as const),
            }))
            // Sorts in descending order by 'severity' to have 'warning' before 'nautral'
            .sort((a, b) => b.severity.localeCompare(a.severity))
    );
};
